import React from 'react';
import { Button, Result, Spin, List, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getFileImport } from '../redux-saga/selectors';
import { FileImportStatus } from '../redux-saga/reducers';
import { fileImportActions } from '../redux-saga/actions';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm';

export const FileImportUploadResult: React.FC = () => {
  const dispatch = useDispatch();
  const { uploadResult } = useSelector(getFileImport);

  const successStatus =
    uploadResult.status === FileImportStatus.DONE
      ? uploadResult.notImportedPilotsNames?.length === 0
        ? 'success'
        : 'info'
      : 'error';

  return (
    <>
      {uploadResult.status === FileImportStatus.ERROR && (
        <Result
          status="error"
          title="Submission failed"
          subTitle="Sorry, something went wrong check files and try again"
          extra={
            <Button
              onClick={() => {
                dispatch(
                  fileImportActions.setUploadResult({
                    status: FileImportStatus.NONE,
                  }),
                );
                dispatch(fileImportActions.setDutyTimeFile(null));
                dispatch(fileImportActions.setFlightInfoFile(null));
              }}
              type="primary"
            >
              Try Again
            </Button>
          }
        />
      )}

      {uploadResult.status === FileImportStatus.VALIDATION && (
        <Result
          status="info"
          title="Validating Data"
          subTitle={
            <span>
              Your data is currently undergoing validation. This may take a few moments. Please stay
              on this page while we ensure the accuracy and completeness of the information
              provided.
            </span>
          }
          extra={<Spin spinning={true}> Validating data </Spin>}
        />
      )}

      {uploadResult.status === FileImportStatus.DONE && (
        <Result
          status={successStatus}
          title="Submission Successfull"
          subTitle={
            <>
              We have successfully processed your submission. A total of{' '}
              {uploadResult.importedActualDutiesAmount || 0} actual duties
              {' and '}
              {uploadResult.importedPlannedDutiesAmount || 0} planned duties have been imported
              {uploadResult.successUpdateActualDutyAmount > 0 && (
                <>
                  {' '}
                  and {uploadResult.successUpdateActualDutyAmount} actual duties have been updated
                </>
              )}
              {uploadResult.successUpdatePlannedDutyAmount > 0 && (
                <>
                  {' '}
                  and {uploadResult.successUpdatePlannedDutyAmount} planned duties have been updated
                </>
              )}
            </>
          }
          extra={
            <>
              <Button
                style={{ marginBottom: 20 }}
                onClick={() => {
                  dispatch(
                    fileImportActions.setUploadResult({
                      status: FileImportStatus.NONE,
                    }),
                  );
                  dispatch(fileImportActions.setDutyTimeFile(null));
                  dispatch(fileImportActions.setFlightInfoFile(null));
                }}
                type="primary"
              >
                Add Another
              </Button>

              {uploadResult.flightsWithoutDuty?.length > 0 && (
                <List
                  size="small"
                  style={{ marginBottom: 20 }}
                  header={
                    <div>
                      <strong>Flights Missing Corresponding Duties</strong>
                      <p>
                        The following flights do not have assigned duties for the listed pilots.
                      </p>
                    </div>
                  }
                  bordered
                  dataSource={uploadResult.flightsWithoutDuty}
                  renderItem={item => (
                    <List.Item>
                      <Typography.Text>
                        {`Flight with takeoff time at ${item.TimeOut.format(
                          DATE_FORMAT,
                        )} and landing time at ${item.TimeIn.format(DATE_FORMAT)}
       does not have an assigned duty. Associated pilot: ${item.Pilot.FirstName} ${
                          item.Pilot.LastName
                        }.`}
                      </Typography.Text>
                    </List.Item>
                  )}
                />
              )}

              {uploadResult.notImportedPilotsNames?.length > 0 && (
                <List
                  size="small"
                  header={
                    <div>
                      <strong>Pilots Not Found in Database</strong>
                      <p>
                        The following pilot names were not found in your company's user list. To
                        import duties, please create a new pilot profile or correct the pilot name
                        if it is misspelled.
                      </p>
                    </div>
                  }
                  bordered
                  dataSource={uploadResult.notImportedPilotsNames}
                  renderItem={item => <List.Item>{item}</List.Item>}
                />
              )}
            </>
          }
        />
      )}
    </>
  );
};
